'use strict';

import 'angular';

import standardResponse from './standard_response';
import jcwAfterHoursModule from './jcw_after_hours';
import ugModule from './ug';
import ugSewerModule from './ug_sewer';
import lovelandModule from './loveland';
import jcwBuppModule from './jcw_bupp';
import durhamModule from './durham';
import olatheModule from './olathe';
import springfieldModule from './springfield';
import arvadaModule from './arvada';
import servproOfBoulderModule from './servpro_of_boulder';
import scmwdModule from './scmwd';
import wichitaPumpStationsModule from './wichita_pump_stations';

const MODULE_NAME = 'daupler.incidents.versions';

angular.module(MODULE_NAME, [
	jcwAfterHoursModule,
]);

export default MODULE_NAME;
